/* eslint-disable @typescript-eslint/promise-function-async */
// گزارش براساس خروجی اکسل

import { Tooltip } from '@mui/material'
import * as FileSaver from 'file-saver'
import React, { FC } from 'react'
import XLSX from 'sheetjs-style'

import Button from './shared/Button'
interface Props {
  excelData: any
  fileName: string
}

const ExcelExport: FC<Props> = ({ excelData, fileName }) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'

  const exportToExcel = (fileName1: any) => {
    const ws = XLSX.utils.json_to_sheet(excelData)
    const wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 10 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ]
    ws['!cols'] = wscols
    const wrowls = [
      { hpt: 20 },
      { hpt: 20 },
      { hpt: 20 },
      { hpt: 20 },
      { hpt: 20 },
      { hpt: 20 },
      { hpt: 20 },
    ]
    ws['!rows'] = wrowls
    ws.A1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.A1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.B1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.C1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.D1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.E1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    /* mehdiws.F1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    }
    ws.G1.s = {
      // set the style for target cell
      font: {
        name: 'aa',
        sz: 12,
        bold: true,
        color: { rgb: 'FFFF0000' },
      },
    } */
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }

    const exelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([exelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  return (
    <>
      <Button onClick={(e: any) => exportToExcel(fileName)}>خروجی اکسل</Button>
    </>
  )
}

export default ExcelExport
